import HomePage from './Componets/HomePage/HomePage';
import CasaOrigen from './Componets/CasaOrigen/CasaOrigen';
import CabañaMar from './Componets/CabañaMar/CabañaMar';
import CabañaPortuguesa from './Componets/CabañaPortuguesa/CabañaPortuguesa';
import Restaurante from './Componets/Restaurante/Restaurante';
import Granja from './Componets/Granja/Granja';
import Spa from './Componets/Spa/Spa';
import Contactos from './Componets/Contactos/Contactos';
import Senderismo from './Componets/Senderismo/Senderismo';
import Cabalgata from './Componets/Cabalgata/Cabalgata';
import Pesca from './Componets/Pesca/Pesca';
import Camping from './Componets/Camping/Camping';
import Navbar from './Componets/Navbar/Navbar'

import Footer from './Componets/Footer/Footer'
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Routes, Route } from 'react-router-dom';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
      <div className="App">
        <Navbar />
        <main>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/casa_origen" element={<CasaOrigen />} />
            <Route path="/cabaña_vista_al_mar" element={<CabañaMar />} />
            <Route path="/cabaña_la_portuguesa" element={<CabañaPortuguesa />} />
            <Route path="/restaurante" element={<Restaurante />} />
            <Route path="/granja" element={<Granja />} />
            <Route path="/senderismo" element={<Senderismo />} />
            <Route path="/cabalgata" element={<Cabalgata />} />
            <Route path="/pesca" element={<Pesca />} />
            <Route path="/camping" element={<Camping />} />
            <Route path="/spa" element={<Spa />} />
            <Route path="/contactos" element={<Contactos />} />
          </Routes>
          <Footer />
        </main>
      </div>
  );
}

export default App;
